import { render } from "./MovementFilterDialog.vue?vue&type=template&id=6f8deab8&scoped=true&ts=true"
import script from "./MovementFilterDialog.vue?vue&type=script&lang=ts"
export * from "./MovementFilterDialog.vue?vue&type=script&lang=ts"

import "./MovementFilterDialog.vue?vue&type=style&index=0&id=6f8deab8&lang=scss&scoped=true"

import exportComponent from "/home/runner/work/olaria-client/olaria-client/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-6f8deab8"]])

export default __exports__